
import {
    TouchableOpacity,
    View
} from "react-native";
import {
    type UserProps,
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    NCoreUIKitLocalize,
    Text
} from "ncore-ui-kit";
import Avatar from "../avatar";

const UserCard = ({
    profilePhotoURL,
    fullName,
    company,
    onPress
}: UserProps) => {
    const {
        radiuses,
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    return <View
        style={{
            ...stylesheet.container
        }}
    >
        <Avatar
            style={{
                borderRadius: radiuses.lg * 3,
                marginRight: spaces.spacingMd
            }}
            imageStyle={{
                ...stylesheet.avatarImage,
                borderRadius: radiuses.lg * 3
            }}
            imageURL={profilePhotoURL}
            name={fullName}
            size={50}
        />
        <TouchableOpacity
            style={{
                ...stylesheet.content
            }}
            onPress={onPress}
        >
            <Text
                style={{
                    marginRight: spaces.spacingMd
                }}
                variant="titleLargeSize"
                color="high"
            >
                {fullName}
            </Text>
            <Text
                style={[
                    stylesheet.companyText,
                    {
                        marginRight: spaces.spacingMd
                    }
                ]}
                variant="bodyMediumSize"
                color="mid"
            >
                {company || localize("notSpecified")}
            </Text>
        </TouchableOpacity>
    </View>;
};
export default UserCard;
